<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.USER'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.USER'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card-title d-flex align-items-center">
                    <h5 class="mb-2" *ngIf="CurrentUrl=='/creators'"><span [translate]="'GREATER.CREATORS'"> </span></h5>
                    <h5 class="mb-2" *ngIf="CurrentUrl=='/organisations'"><span [translate]="'GREATER.ORGANISATIONS'"> </span></h5>
                    <h5 class="mb-2" *ngIf="CurrentUrl=='/users'"><span [translate]="'GREATER.USERS'"> </span></h5>
                </div>
                <hr>
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_NAME_EMAIL'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_NAME_EMAIL' | translate }}" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>                
                <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.NAME'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.EMAIL'"> </span></th>
                                        <th scope="col" *ngIf="CurrentUrl!='/users'"><span [translate]="'GREATER.USERNAME'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.DATE_INIATE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.VERIFIED'"> </span></th>
                                        <th scope="col" class="d-flex"><span [translate]="'GREATER.ACTIVE_DATE'"> </span>
                                        <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td><img [src]="item.profile_image" style="height:100px;width:100px"></td>
                                        <td>{{item.name}} {{item.surname}}</td>
                                        <td>{{item.email}}</td>
                                        <td *ngIf="CurrentUrl!='/users'">{{item.user_handle}}</td>
                                        <td>{{service.convertDate (item.createdAt)}} </td>
                                        <td><div class="form-check">
                                            <input class="form-check-input" type="checkbox" [checked]="item.emailVerified==true" disabled readonly> </div></td>
                                        <td>{{service.convertDate(item.emailVerifiedTime) }} </td>
                                        <td>
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" [checked]="item.status=='Active'" (click)="updateStatus($event,item)"> </div>
                                            <!-- <span class="badge bg-success" *ngIf="item.status =='Active' " (click)="updateStatus($event,item,'Active')">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status == 'Deactive'">{{item.status}}</span> -->
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info text-center" (click)="redirect(item,1)">
                                                    <i class="bx bx-show"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger text-center" (click)="redirect(item,2)">
                                                    <i class="bx bx-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>